module.exports = "<div class=\"col-md-6 blanco\" ng-if=visibilityVM.thereIsDetails()> <div ng-include=\"'visibility-details-header'\"></div> </div> <div class=\"col-md-6 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=visibilityVM.isLoadingDetails> <md-progress-circular md-mode=indeterminate ng-disabled=\"visibilityVM.thereIsDetails() || visibilityVM.searchValue\" md-diameter=96> </md-progress-circular> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/extensionVisibility/visibility/list/visibility-details.html
// module id = 674
// module chunks = 0